<template>
  <div class="offline-business-order-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "OfflineBusinessOrderIndex"
};
</script>

<style lang="less" scoped>
.offline-business-order-container {
  padding: 20px;
  height: 100%;
}
</style>
